const FEATURE_TOGGLE_NAME_DELIMITER = ',';

const FEATURE_TOGGLE_NAMES = {
  DISPLAY_GLOBAL_CAMPAIGN_TEXT: 'DisplayGlobalCampaignText',
  USE_ARWEN_FOR_SUGGESTIONS_ON_MOBILE: 'UseArwenForSuggestionsOnMobile',
  USE_STATIC_CONTENT_FOR_TRENDING: 'UseStaticContentForTrending',
  DISPLAY_RECOMMENDATIONS: 'Recommendation',
  ENABLE_ENSIGHTEN: 'EnableEnsighten',
  PAGE_LIMIT_IN_LISTING_PAGES: 'PageLimitInListingPages',
  DISPLAY_ITEM_COUNT_ON_CART_SF: 'DisplayItemCountOnCartSF',
  USE_BLACK_FRIDAY_THEME_MOBILE: 'UseBlackFridayThemeMobile',
  USE_BLACK_FRIDAY_THEME_DESKTOP: 'UseBlackFridayThemeDesktop',
  DISPLAY_FEEDBACK: 'DisplayFeedbackForListingPages',
  DISPLAY_FEEDBACK_PWA_DESKTOP: 'DisplayFeedbackForPwaDesktopPages',
  DISPLAY_FILTER_WIDGET: 'DisplayFilterWidget',
  PAGE_LIMIT_IN_SEARCH: 'PageLimitInSearch',
  DESKTOP_PAGE_LIMIT_IN_SEARCH: 'DesktopPageLimitInSearch',
  DISPLAY_THIRD_PRICE_WITH_BASKET: 'DisplayThirdPriceWithBasket',
  USE_HIGH_QUALITY_IMAGES: 'UseHighQualityImages',
  DISPLAY_DICTIONARY_CONTENT: 'DisplayDictionaryContent',
  DISPLAY_DICTIONARY_CONTENT_FOR_PWA_DESKTOP_PAGES: 'DisplayDictionaryContentForPwaDesktopPages',
  SHOW_PLP_REDESIGN_LAYOUT: 'ShowPLPRedesignLayout',
  ENABLE_GTM: 'EnableGTM',
  DISPLAY_GOOGLE_ADS: 'DisplayGoogleAds',
  DISPLAY_DOWNLOAD_APP_POPUP_ON_MOBILE: 'DisplayDownloadAppPopupOnMobile',
  ENABLE_ABTEST: 'EnableAbTest',
  SERVER_SIDE_RENDER_FOR_PWA_OTHER_PAGE: 'ServerSideRenderForPwaOtherPage',
  SERVER_TO_CLIENT_SEND_INITIAL_DATA_FOR_PWA_OTHER_PAGE: 'ServerToClientSendInitialDataForPwaOtherPage',
  DISPLAY_SPECIAL_CAMPAIGN_ON_CAMPAIGN_PAGE: 'DisplaySpecialCampaignOnCampaignPage',
  DISPLAY_SPECIAL_CAMPAIGN_ON_PDP_PAGE: 'DisplaySpecialCampaign',
  DISPLAY_WHATSAPP_ICON: 'DisplayWhatsappIcon',
  DISPLAY_TABBAR: 'DisplayTabbar',
  DISPLAY_LIKE_BUTTON_ON_LISTING_PAGES: 'DisplayLikeButtonOnListingPages',
  IS_PERSONAL_HEROUSEL_AVAILABLE: 'IsPersonalHerouselAvailable',
  DISPLAY_CATEGORY_PAGES_FROM_CMS: 'DisplayCategoryPagesFromCms',
  DISPLAY_PWA_DESKTOP_CATEGORY_PAGES_FROM_CMS: 'DisplayPwaDesktopCategoryPagesFromCms',
  USE_CHECKOUT_VOLTRAN_ADD_TO_CART_OTHER_PAGE: 'UseCheckoutVoltranAddToCartOtherPage',
  DISPLAY_JET_DELIVERY_WIDGET: 'DisplayJetDeliveryWidget',
  ENABLE_JET_DELIVERY_ON_PWA_MOBILE_LISTING: 'EnableJetDeliveryOnPwaMobileListing',
  SHOW_QUICK_FILTER: 'ShowQuickFilter',
  LOAD_QUICK_FILTER_ON_CLIENT_SIDE: 'LoadQuickFilterOnClientSide',
  SHOW_JET_DELIVERY_IN_QUICK_FILTER: 'ShowJetDeliveryInQuickFilter',
  OPEN_TABBAR_CACHE: 'OpenTabbarCache',
  DISPLAY_CAMPAIGN_FILTER: 'DisplayCampaignFilter',
  SERVER_SIDE_RENDER_FOR_PWA_HOME_PAGE: 'ServerSideRenderForPwaHomePage',
  SERVER_SIDE_RENDER_FOR_PWA_MOBILE_HOME_PAGE: 'ServerSideRenderForPwaMobileHomePage',
  SERVER_TO_CLIENT_SEND_INITIAL_DATA_FOR_PWA_HOME_PAGE: 'ServerToClientSendInitialDataForPwaHomePage',
  SERVER_TO_CLIENT_SEND_INITIAL_DATA_FOR_PWA_MOBILE_HOME_PAGE: 'ServerToClientSendInitialDataForPwaMobileHomePage',
  SERVER_SIDE_RENDER_FOR_PWA_CATEGORY_PAGE: 'ServerSideRenderForPwaCategoryPage',
  SERVER_SIDE_RENDER_FOR_PWA_DESKTOP_CATEGORY_PAGE: 'ServerSideRenderForPwaDesktopCategoryPage',
  SERVER_TO_CLIENT_SEND_INITIAL_DATA_FOR_PWA_CATEGORY_PAGE: 'ServerToClientSendInitialDataForPwaCategoryPage',
  SERVER_TO_CLIENT_SEND_INITIAL_DATA_FOR_PWA_DESKTOP_CATEGORY_PAGE: 'ServerToClientSendInitialDataForPwaDesktopCategoryPage',
  SERVER_TO_CLIENT_SEND_INITIAL_DATA_FOR_PWA_DESKTOP_SEARCH_PAGE: 'ServerToClientSendInitialDataForPwaDesktopSearchPage',
  SERVER_TO_CLIENT_SEND_INITIAL_DATA_FOR_PWA_DESKTOP_TAG_PAGE: 'ServerToClientSendInitialDataForPwaDesktopTagPage',
  SERVER_SIDE_RENDER_FOR_PWA_SEARCH_PAGE: 'ServerSideRenderForPwaSearchPage',
  SERVER_SIDE_RENDER_FOR_PWA_DESKTOP_SEARCH_PAGE: 'ServerSideRenderForPwaDesktopSearchPage',
  SERVER_TO_CLIENT_SEND_INITIAL_DATA_FOR_PWA_SEARCH_PAGE: 'ServerToClientSendInitialDataForPwaSearchPage',
  SERVER_SIDE_RENDER_FOR_PWA_TAG_PAGE: 'ServerSideRenderForPwaTagPage',
  SERVER_SIDE_RENDER_FOR_PWA_DESKTOP_TAG_PAGE: 'ServerSideRenderForPwaDesktopTagPage',
  SERVER_TO_CLIENT_SEND_INITIAL_DATA_FOR_PWA_TAG_PAGE: 'ServerToClientSendInitialDataForPwaTagPage',
  SERVER_SIDE_RENDER_FOR_PWA_BRAND_PAGE: 'ServerSideRenderForPwaBrandPage',
  SERVER_SIDE_RENDER_FOR_PWA_MERCHANT_PAGE: 'ServerSideRenderForPwaMerchantPage',
  SERVER_TO_CLIENT_SEND_INITIAL_DATA_FOR_PWA_BRAND_PAGE: 'ServerToClientSendInitialDataForPwaBrandPage',
  SERVER_TO_CLIENT_SEND_INITIAL_DATA_FOR_PWA_MERCHANT_PAGE:'ServerToClientSendInitialDataForPwaMerchantPage',
  SERVER_SIDE_RENDER_FOR_PWA_STATIC_PAGE: 'ServerSideRenderForPwaStaticPage',
  SERVER_TO_CLIENT_SEND_INITIAL_DATA_FOR_PWA_STATIC_PAGE: 'ServerToClientSendInitialDataForPwaStaticPage',
  SERVER_SIDE_RENDER_FOR_PWA_CAMPAIGN_PAGE: 'ServerSideRenderForPwaCampaignPage',
  SERVER_TO_CLIENT_SEND_INITIAL_DATA_FOR_PWA_CAMPAIGN_PAGE: 'ServerToClientSendInitialDataForPwaCampaignPage',
  ENABLE_DEEP_LINK_QUESTIONING: 'EnabledDeepLinkQuestioning',
  HIDE_JS_FROM_GOOGLEBOT: 'HideJSfromGooglebot',
  DISPLAY_MFE_DELIVERY_OPTIONS: 'DisplayMFEDeliveryOptions',
  HOMEPAGE_CMS: 'HomePageCms',
  PERSONALIZED_HOMEPAGE_CMS: 'PersonalizedHomepageCms',
  DISPLAY_EXPRESS_DELIVERY: 'DisplayExpressDelivery',
  DISPLAY_NEXT_DAY_DELIVERY: 'DisplayNextDayDelivery',
  IS_PERSONALIZED_AVAILABLE_HOME_PAGE: 'IsPersonalizedAvailableHomePage',
  SERVER_SIDE_RENDER_FOR_PWA_PRODUCT_DETAIL: 'ServerSideRenderForPwaProductDetail',
  SERVER_TO_CLIENT_SEND_INITIAL_DATA_FOR_PWA_PRODUCT_DETAIL: 'ServerToClientSendInitialDataForPwaProductDetail',
  CALL_USER_CONTENT_SERVICE_ON_PRODUCT_DETAIL: 'CallUserContentServiceOnProductDetail',
  CALL_USER_CONTENT_SERVICE_ON_CLIENT_SIDE: 'CallUserContentServiceOnClientSide',
  IS_SFST_PERSONALIZED_HOME_PAGE: 'IsSfstPersonalizedOnHomePage',
  ASK_TO_MERCHANT_ENABLED: 'AskToMerchantEnabled',
  CALL_QUESTION_ANSWER_TAB_SERVER_SIDE: 'CallQuestionAnswerTabServerSide',
  CALL_QUESTION_ANSWER_TAB_CLIENT_SIDE: 'CallQuestionAnswerTabClientSide',
  CALL_QUESTION_ANSWER_PWA: 'CallQuestionAnswerPwa',
  CALL_QUESTION_ANSWER_PWA_CLIENT_SIDE: 'CallQuestionAnswerPwaClientSide',
  IS_LOCATION_AWARE_AVAILABLE: 'IsLocationAwareAvailable',
  DISPLAY_HEPSIGLOBAL_MODAL: 'DisplayHepsiglobalModal',
  DISPLAY_MFE_BEST_REVIEW: 'DisplayMFEBestReview',
  DISPLAY_CLIENT_MFE_BEST_REVIEW: 'DisplayClientMFEBestReview',
  IS_CUSTOMER_INFO_ENABLED: 'IsCustomerInfoEnabled',
  DISPLAY_BANNER_ENABLED_FOR_TAG_PAGE: 'DisplayBannerEnabledForTagPage',
  DISPLAY_BANNER_ENABLED_FOR_CATEGORY_PAGE: 'DisplayBannerEnabledForCategoryPage',
  SHOW_DEFAULT_FILTER_AND_SORTING_BOXES: 'ShowDefaultFilterAndSortingBoxes',
  DISPLAY_BANNER_ENABLED_FOR_DESKTOP_TAG_PAGE: 'DisplayBannerEnabledForDesktopTagPage',
  DISPLAY_BANNER_ENABLED_FOR_DESKTOP_SEARCH_PAGE: 'DisplayBannerEnabledForDesktopSearchPage',
  DISPLAY_BANNER_ENABLED_FOR_DESKTOP_CATEGORY_PAGE: 'DisplayBannerEnabledForDesktopCategoryPage',
  CAC_CAMPAIGN_BUNDLE: 'CacCampaignBundle',
  DISPLAY_SPONSORED_BRAND_COMPONENT: 'DisplaySponsoredBrandComponent',
  DISPLAY_SPONSORED_BRAND_FOR_PWA_DESKTOP: 'DisplaySponsoredBrandForPwaDesktop',
  DISPLAY_MERCHANT_ROW:'DisplayMerchantRow',
  DISPLAY_MERCHANT_ROW_MOBILE:'DisplayMerchantRowMobile',
  DISPLAY_MERCHANT_SEARCH_BAR:'DisplayMerchantSearchBar',
  DISPLAY_MERCHANT_ABOUT_SELLER:'DisplayMerchantAboutSeller',
  IS_DISPLAY_LOYALTY_PREMIUM_ON_PDP: 'IsDisplayLoyaltyPremiumOnPdp',
  IS_DISPLAY_MERCHANT_COUPONS_ON_PDP: 'IsDisplayPdpCoupon',
  USE_CLIENT_SIDE_ROUTE_PLP: 'UseClientSideRoutePlp',
  ENABLE_MERCHANT_FOLLOW_BUTTON: 'EnableMerchantFollowButton',
  DISPLAY_COMMENTS_NEW_MWEB: 'DisplayCommentsNewMweb',
  DISPLAY_RECO_PRODUCTS_FOR_CATEGORY_PAGE: 'DisplayRecoProductsForDesktopCategoryPage',
  DISPLAY_RECO_PRODUCTS_FOR_DESKTOP_TAG_PAGE: 'DisplayRecoProductsForDesktopTagPage',
  REMOVE_VOLTRAN_SCRIPTS_INITIAL_LOAD: 'RemoveVoltranScriptsInitialLoad',
  ENABLE_DESKTOP_STICKY_VERTICAL_FILTER_FROM_PWA: 'EnableDesktopStickyVerticalFilterFromPWA',
  SERVER_SIDE_RENDER_FOR_PWA_DYNAMIC_VIEW_PAGE: 'ServerSideRenderForPwaDynamicViewPage',
  SERVER_TO_CLIENT_SEND_INITAL_DATA_FOR_PWA_DYNAMIC_VIEW_PAGE: 'ServerToClientSendInitialDataForPwaDynamicViewPage',
  ENABLE_POSTBACK_ON_PLP_FILTER_SUBMIT: 'EnablePostbackOnPlpFilterSubmit',
  IS_CRITICAL_CSS: 'IsCriticalCss',
  ENABLE_FRIENDLY_URLS_FOR_CATEGORY_PAGES: 'EnableFriendlyUrlsForCategoryPages',
  ONLY_SINGLE_PRODUCT_IMAGE: 'OnlySingleProductImage',
  DISPLAY_SARDES_MFE_LOAN_TAB: 'DisplaySardesMFELoanTab',
  DISPLAY_SARDES_MFE_INSTALLMENT_TAB: 'DisplaySardesMFEInstallmentTab',
  DISPLAY_MFE_PRODUCT_DESCRIPTION: 'DisplayMFEProductDescription',
  DISPLAY_MFE_CLIENT_SIDE_PRODUCT_DESCRIPTION: 'DisplayMFEClientSideProductDescription',
  DISPLAY_WINNER_CAMPAIGN: 'DisplayWinnerCampaign',
  DISPLAY_ADD_TO_MY_LIST: 'DisplayAddToMyList',
  DISPLAY_CAMPAIGN_SECTION: 'DisplayCampaignSection',
  USE_VAS_SERVICE: 'UseVasService',
  DISPLAY_COMPARED_TOP_SELLER_PRODUCT_PDP: 'DisplayComparedTopSellerProductsPdp',
  DISPLAY_COMPARED_TOP_SELLER_PRODUCTS_CATEGORY: 'DisplayComparedTopSellerProductsCategory',
  DISPLAY_COMPARED_TOP_SELLER_PRODUCTS_SEARCH: 'DisplayComparedTopSellerProductsSearch',
  DISPLAY_SIMILAR_BRANDS_ON_BRAND_PAGE: 'DisplaySimilarBrandsOnBrandPage',
  SERVER_SIDE_RENDER_FOR_PWA_PRODUCT_COMMENT_PAGE: 'ServerSideRenderForPwaProductCommentPage',
  SERVER_TO_CLIENT_SEND_INITIAL_DATA_FOR_PWA_PRODUCT_COMMENT_PAGE: 'ServerToClientSendInitialDataForPwaProductCommentPage',
  SERVER_SIDE_RENDER_FOR_PWA_PRODUCT_QNA_PAGE: 'ServerSideRenderForPwaProductQnaPage',
  SERVER_TO_CLIENT_SEND_INITIAL_DATA_FOR_PWA_PRODUCT_QNA_PAGE: 'ServerToClientSendInitialDataForPwaProductQnaPage',
  DISPLAY_POPULAR_SEARCH_KEYWORDS_ON_CATEGORY_PAGE:'DisplayPopularSearchKeywordsOnCP',
  DISPLAY_POPULAR_SEARCH_KEYWORDS_ON_SEARCH_PAGE:'DisplayPopularSearchKeywordsOnSP',
  IS_NEW_LISTING_PRICE_AREA_ENABLED:'IsNewListingPriceAreaEnabled',
  DISPLAY_DUE_DATE_ON_MWEB_LISTING_PAGES:'DisplayDueDateOnMwebListingPages',
  DISPLAY_ADX_BANNER_MWEB: 'DisplayAdxBannerMweb',
  ENABLE_ERROR_FEEDBACK_BUTTON:'EnableErrorFeedbackButton',
  DISPLAY_CARD_AND_INSTALLMENT_INFO_ON_PDP: 'DisplayCardAndInstallmentInfoOnPdp',
  DISPLAY_CAMPAIGN_INFO_ON_PDP: 'DisplayCampaignInfoOnPdp',
  DISPLAY_DUE_DATE_INFO_ON_PDP: 'DisplayDueDateInfoOnPdp',
  NEW_CARDS_ON_MWEB_LISTING_WITH_NEW_PACKAGES:'NewCardsOnMwebListingWithNewPackages',
  IS_NEW_CARDS_ON_HOMEPAGE_RECOMMENDATION : 'IsNewCardsOnHomepageRecommendation'
};

export {
  FEATURE_TOGGLE_NAMES,
  FEATURE_TOGGLE_NAME_DELIMITER,
};
